<template>
  <div class="h-screen flex bg-gray-200">
    <vc-navigation v-if="excluded" />
    <transition name="slide" mode="out-in">
      <router-view />
    </transition>
    <div v-if="isModalOpen" class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white rounded-lg shadow-lg w-full max-w-md">
      <div class="border-b px-4 py-2">
        <slot name="header">
        <h3 class="text-lg font-semibold">{{ $t('login.salir') }}</h3>
        </slot>
      </div>
      <div class="px-4 py-4">
        <slot name="body">
        <p>{{ $t('login.salirModal') }}</p>
        </slot>
      </div>
      <div class="border-t px-4 py-2 flex justify-end">
        <slot name="footer">
            <button class="px-4 py-2 bg-orange-400 text-white rounded mr-2" @click="closeModal">No</button>
          <button class="px-4 py-2 bg-orange-400 text-white rounded" @click="doLogout ">Sí</button>
        </slot>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import Navigation from "@/components/Navigation.vue";

export default {
  name: "App",
  data() {
    return {
      excludedRoutes: [
        "login",
        "singup",
        "changepassword",
        "forgotPassword",
        "newUser",
      ],
    };
  },
  computed: {
    ...mapGetters({
      hasToken: "auth/hasToken",
      getExpirationDate: "auth/getExpirationDate",
    }),
    ...mapState("auth", ["isModalOpen"]),
    excluded() {
      return this.excludedRoutes.indexOf(this.$route.name) == -1;
    },
  },
  components: {
    "vc-navigation": Navigation,
  },
  methods: {
    ...mapActions({
      logoutTimeout: "auth/logoutTimeout",
    }),
    doLogout() {
      this.$store.commit("auth/setModal", false);
      this.$store.dispatch("auth/logout");
    },
    closeModal() {
      this.$store.commit("auth/setModal", false);
    },
  },
  watch: {
    hasToken(newTokenValue) {
      if (!newTokenValue) {
        this.$router.push({ name: "login" });
      }
    },
  },
  created() {
    if (this.getExpirationDate > 0) {
      const timeLeft = this.getExpirationDate - new Date().valueOf();
      this.logoutTimeout(timeLeft);
    }
  },
};
</script>

<style scoped>
.slide-enter-active {
  animation: slide-in 200ms ease-out forwards;
}

.slide-leave-active {
  animation: slide-out 200ms ease-out forwards;
}

@keyframes slide-in {
  from {
    transform: translateY(-30px);
    opacity: 0;
  }

  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
    opacity: 1;
  }

  to {
    transform: translateY(-30px);
    opacity: 0;
  }
}
</style>
